import React, { Fragment, useEffect, useState } from 'react';
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import TableProviderDocuments from "root/Tables/TableProviderDocuments";
import {getProviderDocuments} from "root/DataFunctions/DocumentFns";
import useModalUploadDocument, { UploadDocumentMode, UploadDocumentResult } from "root/Modals/useModalUploadDocument";
import ContainerButton from "root/ContainerButton";
import { isGovernorRole } from "root/DataFunctions/GovernorFunctions";
import { useGlobalContext } from "root/Contexts/GlobalContext";

const DocumentsContainer = (props) =>
{

    const {user_type} = useGlobalContext();

    const [data, setData] = useState({loading: true, data: []});
    const [renderUploadModal, activateUploadModal ] = useModalUploadDocument() ;

    useEffect(() => {
        getData();
    }, []);

    const getData = () =>
    {
        getProviderDocuments( props.provider_id, (response) =>
        {
            const returnData = getDataFromResponse(response) ;

            setData({loading: false, data: returnData})
        })
    }

    const onDialogClosed = (result) =>
    {
        if ( result === UploadDocumentResult.SAVED )
        {
            getData() ;
        }
    }

    const onClickUpload = () =>
    {
        activateUploadModal ( props.provider_id, UploadDocumentMode.UPLOAD, null, onDialogClosed ) ;
    }

    const onClickDelete = ( enc_doc_id ) =>
    {
        activateUploadModal ( props.provider_id, UploadDocumentMode.DELETE, enc_doc_id, onDialogClosed ) ;
    }

    return (
        <Fragment>
            <div className='container-for-tabs'>
            <TableProviderDocuments data={data} allowDelete={!isGovernorRole(user_type)} onClick={onClickDelete}/>
                {!isGovernorRole(user_type) && <ContainerButton onClick={onClickUpload} title='Upload A New Document'/>}
            {renderUploadModal()}
            </div>
        </Fragment>
    )
}

export default DocumentsContainer;
